/**
 * Created by Ivan on 17.11.2025
 * Refactored by Claude on 29.01.2026
 */

RiddlesLevelMasteryWindow = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        ComponentMap.attach(this, new WindowComponent(["levelmastery_window"]));
    },

    onWindowLoaded: function (mission) {
        this.withShadow = true;

        const windowView = this;
        const closeWindowCallback = () => {
            ComponentMap.get(this, WindowComponent).closeWindow();
        };

        this.resizable = new Resizable({
            createHorizontalView: function () {
                return new RiddlesLevelMasteryHorizontal(mission, { closeWindowCallback });
            },
            createVerticalView: function () {
                return new RiddlesLevelMasteryVertical(mission, { closeWindowCallback, windowView });
            }
        });
        ComponentMap.attach(this, this.resizable);

        this.onResize();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        if (this.resizable) {
            this.resizable.onResize();
        }
    }
});
